import { Injectable } from '@angular/core';
import { IMask } from 'angular-imask';
import { IMaskConstants } from '../../constants/imask';

@Injectable({
    providedIn: 'root',
})
export class PostalCodeService {
    /**
     * Builds a formatted postal code string.
     *
     * @param postalCode The main postal code part.
     * @param postalCodeSuffix The optional postal code suffix.
     * @returns The formatted postal code string.
     */
    buildPostalCodeString(
        postalCode: string,
        postalCodeSuffix: string | null = null,
    ): string {
        const combinedPostalCode = `${(postalCode ?? '').trim()}${(postalCodeSuffix ?? '').trim()}`;

        const masked = IMask.createMask(IMaskConstants.postalCode.mask);
        masked.resolve(combinedPostalCode);
        return masked.value;
    }
}
